import { generatePath } from "react-router-dom"

export function getChecklistSubmitUrl({
    orgId,
    checklistId,
    missionIds = [],
}: {
    orgId: string
    checklistId: string
    missionIds?: string[]
}) {
    const path = generatePath("/checklist/:orgId/:checklistId", { orgId, checklistId })
    const region = JSON.parse(sessionStorage.getItem("region") || "null")
    const params: Record<string, string> = {}
    if (missionIds.length > 0) params.missionIds = missionIds.join(",")
    if (region) params.region = region
    const searchParams = new URLSearchParams(params).toString()
    return path + (searchParams && `?${searchParams}`)
}
